import React, { useEffect, useState } from "react";
import FeaturedCard from "./FeaturedCard";
import axios from "axios";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

function FeaturedItems({
  foodMenus,
  settings,
  setFoodMenus,
  loader,
  setSubData,
  subData,
  currency
}) {
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const customer = JSON.parse(localStorage.getItem("rms-customer"));

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/foodMenus`, {
        params: {
          outletId: outlet?.outlet.id,
          customer_id: customer?.customer?.id,
        },
      })
      .then((res) => {
        setFoodMenus(res.data.foodMenus);
        setSubData(res.data.subscriber_merged_categories_quantity);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [
    customer?.customer?.id,
    customer?.id,
    outlet?.outlet.id,
    setFoodMenus,
    setSubData,
  ]);

  if (isLoading) {
    return (
      <div className="w-full grid place-items-center h-64">
        <img src={loader?.loader_url} className="w-16" alt="loading..." />
      </div>
    );
  }

  return (
    <section className="my-8">
      <div className="max-w-7xl w-[90%] mx-auto">
        <h2 className="text-2xl font-bold text-w-heading">
          {" "}
          {languageHelper("featured items") || "Featured Items"}
        </h2>
        <div className="my-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {foodMenus.map((menu, index) => {
            const now = new Date();
            const timeString =
              now.getHours().toString().padStart(2, "0") +
              ":" +
              now.getMinutes().toString().padStart(2, "0") +
              ":" +
              now.getSeconds().toString().padStart(2, "0");

            const isTimeInRange = (current, start, end) => {
              if (!start || !end) return false;

              const toSeconds = (timeStr) => {
                const [h, m, s] = timeStr.split(":").map(Number);
                return h * 3600 + m * 60 + s;
              };

              const currentSec = toSeconds(current);
              const startSec = toSeconds(start);
              const endSec = toSeconds(end);

              if (startSec <= endSec) {
                // Normal same-day range
                return currentSec >= startSec && currentSec <= endSec;
              } else {
                // Overnight range
                return currentSec >= startSec || currentSec <= endSec;
              }
            };

            const isEnabled = menu.category?.category_schedule
              ? isTimeInRange(
                timeString,
                menu.category.category_schedule?.start_time,
                menu.category.category_schedule?.end_time
              )
              : true;
            return isEnabled && (
            <FeaturedCard
              key={index}
              menu={menu}
              settings={settings}
              currency={currency}
              subData={subData.filter(
                (item) => item.category_id === menu.category_id
              )[0]}
            />
          )})}
        </div>
      </div>
    </section>
  );
}

export default FeaturedItems;
